import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { QuicklinkModule } from 'ngx-quicklink';
import { HttpClientModule } from '@angular/common/http';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { OserviceService } from './api/oservice.service';
import { PageInfoService } from './api/page-info.service';
import { ClientService } from './api/client.service';
import { BlogService } from './api/blog.service';
import { MediaService } from './api/media.service';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { BreadcrumbModule } from 'angular-crumbs';
import { NotFoundComponent } from './not-found/not-found.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    NotFoundComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    QuicklinkModule,
    BreadcrumbModule,
    HttpClientModule
  ],
  providers: [OserviceService, PageInfoService, ClientService, BlogService, MediaService],
  bootstrap: [AppComponent]
})
export class AppModule { }
